export const adaptAllUsuarioAutorizador = (usuario) => {
    return {
        id: usuario?.idUsuario,
        displayName: usuario?.apellido + " " +usuario?.nombre
    }
}

export const adaptAllUsuarioAutorizadorArray = (
    usuarios
) => {
    return structuredClone(usuarios?.allUsuarioAutorizadorPrecioMasivo)
        ?.map(usuario => adaptAllUsuarioAutorizador(usuario));
}